module.exports = "<section class=\"station-container\">\n  <div *ngIf=\"!station\" class=\"station-error\">\n    <p>Nie udało się pobrać danych stacji pogodowej!</p>\n  </div>\n  <div *ngIf=\"station\" class=\"station-data\">\n    <app-chart [station]=\"station\"></app-chart>\n  </div>\n</section>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/station/station.component.html
// module id = 311
// module chunks = 1